import { Outlet, Navigate } from 'react-router-dom';
import { URLS } from '.';
import { useAuthStatus, checkPersistedAuth } from '../store/hooks/useAuth';
import { useEffect, useState } from 'react';

const PrivateRoutes = () => {
    const isAuth = useAuthStatus();
    const [isChecked, setIsChecked] = useState(false);
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    
    useEffect(() => {
        // Check both Redux state and direct localStorage check
        const persistedAuthState = checkPersistedAuth();
        
        if (isAuth || persistedAuthState) {
            setIsAuthenticated(true);
        }
        
        setIsChecked(true);
    }, [isAuth]);
    
    console.log('~~~~~~~~~PRIVATE~~~~~~~~~~~~~~~~', isAuth, isAuthenticated);
    
    // Show nothing while checking to prevent flash of redirects
    if (!isChecked) {
        return null;
    }
    
    return isAuthenticated ? <Outlet /> : <Navigate to={URLS.AUTH.SIGNIN} replace />;
}

export default PrivateRoutes;